import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as g, S as v } from "./icons.types-0722eef5.js";
function u({ title: a, titleId: h, size: i, width: n, height: o, extended: t = !1, ...e }) {
  const r = t ? g : v, c = i ? r[i] : n || r[t ? "s" : "l"], s = i ? r[i] : o || r[t ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: c,
      height: s,
      "aria-labelledby": h,
      ...e,
      children: [
        a ? /* @__PURE__ */ l("title", { id: h, children: a }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Charge_Station_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M48.183 43.412H41.75l4.72-17.017c.234-.686-.118-1.421-.828-1.741-.716-.32-1.58-.127-2.047.455L22.543 49.282a1.346 1.346 0 0 0-.177 1.539c.271.499.837.818 1.456.82h6.433l-4.72 17.025c-.195.676.168 1.385.867 1.688.7.304 1.541.122 2.008-.44l21.054-24.172a1.35 1.35 0 0 0 .184-1.513c-.274-.5-.842-.819-1.465-.817ZM36.003 1.5 53.25 15.583v-5.536h8.63v12.81l8.62 7.04c-1.463 1.691-3.97 1.97-5.768.702l-.309-.241L61.88 28.2v33.1H40.386l3.721-4.272h13.456V24.536L36.002 7.128 14.436 24.576v32.452h10.82L24.074 61.3H10.12V28.235l-2.543 2.137a4.336 4.336 0 0 1-5.808-.178L1.5 29.91 36.002 1.5Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Charge_Station_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  u as ChargeStation
};
